import { DatiDepositoDTO } from "./dati-deposito-dto";

export class DatiDepositoNoEsproprioDTO extends DatiDepositoDTO {
	codiceRtsInoltro: string;
}